export const GET_USER_ACCOUNT_PENDING = 'userDetails/getUserAccount/pending';
export const GET_USER_ACCOUNT_FULFILLED = 'userDetails/getuserAccountFulfilled/fulfilled';
export const GET_USER_ACCOUNT_REJECTED = 'userDetails/getuserAccountRejected/rejected';